import { render, staticRenderFns } from "./broadcastDetail.vue?vue&type=template&id=2073990a&scoped=true&"
import script from "./broadcastDetail.vue?vue&type=script&lang=js&"
export * from "./broadcastDetail.vue?vue&type=script&lang=js&"
import style0 from "./broadcastDetail.vue?vue&type=style&index=0&id=2073990a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073990a",
  null
  
)

component.options.__file = "broadcastDetail.vue"
export default component.exports